/* @jsx mdx */
  import React from 'react'
  import { mdx } from '@mdx-js/react'
  /* @jsx mdx */
import { Playground, Props } from 'docz'
import Box from './'
import { Callout } from '../../index.components'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "box"
    }}>{`Box`}</h1>
    <p>{`Generic container for handling layout.`}</p>
    <h2 {...{
      "id": "import"
    }}>{`Import`}</h2>
    <p><inlineCode parentName="p">{`import { Box } from '@blasterjs/core'`}</inlineCode></p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <p>{`All components in Blaster are built on top of the `}<inlineCode parentName="p">{`<Box>`}</inlineCode>{` primitive. Any component in Blaster can use `}<inlineCode parentName="p">{`Box`}</inlineCode>{`'s props unless specifically overriden.`}</p>
    <p>{`The primitive component `}<inlineCode parentName="p">{`<Box>`}</inlineCode>{` provides an abstraction on top of the `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` element to include reset styles and allows you to specify CSS attributes as props to adjust spacing, display, size, positioning and layout.`}</p>
    <Playground __position={0} __code={'<Box>This is a box</Box>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Box,
      Callout
    }} mdxType="Playground">
    <Box mdxType="Box">This is a box</Box>
    </Playground>
    <h2 {...{
      "id": "prop-styling"
    }}>{`Prop styling`}</h2>
    <Playground __position={1} __code={'<Box display=\"flex\" justifyContent=\"space-around\">\n  <Box>flex 1</Box>\n  <Box>flex 2</Box>\n</Box>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Box,
      Callout
    }} mdxType="Playground">
    <Box display="flex" justifyContent="space-around" mdxType="Box">
        <Box mdxType="Box">flex 1</Box>
        <Box mdxType="Box">flex 2</Box>
    </Box>
    </Playground>
    <Callout icon="info" mdxType="Callout">
    If you would like to apply color and other stylistic decisions, it is recommended to create a new component extending Box.
    </Callout>
    <h3 {...{
      "id": "proptypes"
    }}>{`PropTypes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Prop`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`tag`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`div`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`html tag to be rendered`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${display}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${space}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${width}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${maxWidth}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${minWidth}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${height}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${maxHeight}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${minHeight}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${verticalAlign}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${alignItems}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${justifyContent}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${flexWrap}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${flexDirection}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${flex}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${alignContent}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${justifyItems}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${justifySelf}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${alignSelf}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${order}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${flexBasis}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridGap}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridRowGap}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridColumnGap}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridColumn}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridRow}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridArea}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridAutoFlow}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridAutoRows}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridAutoColumns}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridTemplateRows}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridTemplateColumns}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${gridTemplateAreas}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${overflow}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${position}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${zIndex}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${top}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${right}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${bottom}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${left}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${color}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${background}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${borders}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${boxShadow}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number or string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`\${opacity}`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`number`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`see `}<a parentName="td" {...{
              "href": "https://jxnblk.com/styled-system/"
            }}>{`styled-system`}</a></td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}

MDXContent.isMDXComponent = true;
  